import React from "react";
import {useOverrides, Override} from "@quarkly/components";
import {Image, Box, Text, Section} from "@quarkly/widgets";

const defaultProps = {
    "padding": "48px 0 48px 0",
    "sm-padding": "60px 0 60px 0",
    "quarkly-title": "CDZVBenefits",
    "background": "transparent"
};
const overrides = {
    "box": {
        "kind": "Box",
        "props": {
            "width": "50%",
            "lg-width": "100%",
            "lg-margin": "0px 0px 0px 0px",
            "margin": "0px 0px 0px 0px",
            "lg-padding": "0px 0px 0px 0px",
            "lg-justify-content": "center",
            "pointer-events": "none",
            "padding": "0px 0 0px 0",
            "flex": "0 1 auto",
            "order": "0",
            "display": "flex",
            "text-align": "center",
            "position": "relative"
        }
    },
    "image": {
        "kind": "Image",
        "props": {
            "src": "https://uploads.quarkly.io/665dd05e1d712a0023346c54/images/btc_strategy.png?v=2024-06-03T15:59:19.333Z",
            "object-fit": "cover",
            "sm-min-height": "100vw",
            "disableOptimization": false,
            "pointer-events": "none",
            "transition": "transform 0.5s ease-in-out 0s",
            "transform": "translateY(10px)",
            "hover-transform": "translateY(0px)",
            "align-self": "center"
        }
    },
    "box1": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "width": "50%",
            "flex-direction": "column",
            "align-items": "flex-start",
            "lg-width": "100%",
            "lg-align-items": "flex-start",
            "lg-margin": "0px 0px 0px 0px",
            "padding": "48px 10px 8px 64px",
            "justify-content": "center",
            "background": "transparent",
            "md-padding": "36px 40px 8px 40px",
            "sm-padding": "36px 24px 8px 24px",
            "order": "1"
        }
    },
    "text": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 12px 0px",
            "color": "#ffffff",
            "font": "normal 700 24px/1.3 --fontFamily-sans",
            "lg-text-align": "left",
            "sm-text-align": "left",
            "children": "То, чего нет в TradingView"
        }
    },
    "text1": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 40px 0px",
            "color": "rgba(255, 255, 255, 0.7)",
            "font": "normal 400 16px/1.5 --fontFamily-sans",
            "lg-text-align": "left",
            "sm-text-align": "left",
            "children": "Создавайте сложные условия для входа и выхода прямо на графике без программирования."
        }
    },
    "text2": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 12px 0px",
            "color": "#ffffff",
            "font": "normal 700 24px/1.3 --fontFamily-sans",
            "lg-text-align": "left",
            "sm-text-align": "left",
            "children": "Проверка идей без рисков"
        }
    },
    "text3": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 40px 0px",
            "color": "rgba(255, 255, 255, 0.7)",
            "font": "normal 400 16px/1.5 --fontFamily-sans",
            "lg-text-align": "left",
            "lg-margin": "0px 0px 40px 0px",
            "sm-text-align": "left",
            "children": "Протестируйте каждый алгоритм на истории рынка за несколько лет перед тем, как вкладывать реальные деньги."
        }
    },
    "text4": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 12px 0px",
            "color": "#ffffff",
            "font": "normal 700 24px/1.3 --fontFamily-sans",
            "lg-text-align": "left",
            "sm-text-align": "left",
            "children": "Торговля на автопилоте 24/7"
        }
    },
    "text5": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 40px 0px",
            "color": "rgba(255, 255, 255, 0.7)",
            "font": "normal 400 16px/1.5 --fontFamily-sans",
            "lg-text-align": "left",
            "lg-margin": "0px 0px 40px 0px",
            "sm-text-align": "left",
            "children": "Запустите вашу стратегию в облаке — она будет торговать сама, даже когда ваш компьютер или телефон выключены."
        }
    },
    "text6": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 12px 0px",
            "color": "#ffffff",
            "font": "normal 700 24px/1.3 --fontFamily-sans",
            "lg-text-align": "left",
            "sm-text-align": "left",
            "children": "Мгновенная поддержка разработчиков"
        }
    },
    "text7": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 40px 0px",
            "color": "rgba(255, 255, 255, 0.7)",
            "font": "normal 400 16px/1.5 --fontFamily-sans",
            "lg-text-align": "left",
            "lg-margin": "0px 0px 40px 0px",
            "sm-text-align": "left",
            "children": "Не оставайтесь наедине с трудностями. Получайте быстрые ответы на ваши вопросы в нашем Telegram-чате."
        }
    }
};

const CdzvBenefitsRU = props => {
    const {
        override,
        children,
        rest
    } = useOverrides(props, overrides, defaultProps);
    return <Section {...rest}>
        <Override
            slot="SectionContent"
            flex-direction="row"
            flex-wrap="wrap"
            sm-min-width="280px"
            background="rgba(255, 255, 255, 0)"
        />
        <Box {...override("box")}>
            <Image {...override("image")} />
        </Box>
        <Box {...override("box1")}>
            <Text {...override("text")} />
            <Text {...override("text1")} />
            <Text {...override("text2")} />
            <Text {...override("text3")} />
            <Text {...override("text4")} />
            <Text {...override("text5")} />
            <Text {...override("text6")} />
            <Text {...override("text7")} />
        </Box>
        {children}
    </Section>;
};

Object.assign(CdzvBenefitsRU, {
    ...Section,
    defaultProps,
    overrides
});
export default CdzvBenefitsRU;